<template>
  <v-dialog v-model="dialog" max-width="500px" persistent @keydown.esc="close()">
    <v-form ref="formRegistra">
      <v-card>
        <v-card-text>
          <v-container grid-list-xl pt-0>
            <v-col>
              <v-flex pa-0>
                <v-text-field label="Data reg." v-model="editedItem.DataRegistrazione" readonly></v-text-field>
              </v-flex>
              <v-flex pa-0>
                <v-text-field label="Utente" v-model="editedItem.Utente" readonly></v-text-field>
              </v-flex>
              <v-flex pa-0>
                <v-text-field label="P.iva" v-model="editedItem.Piva" readonly></v-text-field>
              </v-flex>
              <v-flex pa-0>
                <v-text-field label="RagSociale" v-model="editedItem.RagSociale" readonly></v-text-field>
              </v-flex>
              <v-flex pa-0>
                <v-text-field label="E-mail" v-model="editedItem.EMail" readonly></v-text-field>
              </v-flex>

              <v-flex pa-0>
                <v-card dark>
                  <v-card-text primary-title class="pa-1">
                    <p class="headline mb-0 text-md-center">
                      Verifica l'utente con il gestionale
                    </p>
                  </v-card-text>

                  <v-alert :value="!!alertElaborazione" :type="tipo" class="ma-1" transition="scale-transition">{{
                    alertElaborazione }}</v-alert>

                  <v-card-text class="pa-1">
                    Codice : {{ datiUtente.Codice }}<br />
                    Rag.Sociale : {{ datiUtente.RagSociale }}<br />
                    Tipologia : {{ datiUtente.Tipologia }}<br />
                    <v-text-field class="mt-2" outlined label="E-mail di invio conferma"
                      v-model="datiUtente.EMailConferma"></v-text-field>
                  </v-card-text>

                  <v-card-actions class="pa-1">
                    <v-btn text color="orange" v-on:click="verifica" :disabled="attesaVerifica"
                      :loading="attesaVerifica">Verifica</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="orange" v-on:click="conferma" :disabled="attesaConferma"
                      :loading="attesaConferma" v-if="utenteValido && utenteConfermato == false">Conferma e invia
                      mail</v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-col>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn color="black" text icon @click.native="elimina()" v-on="on">
                <v-icon medium>delete</v-icon>
              </v-btn>
            </template>
            <span>Elimina</span>
          </v-tooltip>

          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.native="close">Annulla</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>


<script>
import {
  get_userNew,
  get_userNewValidate,
  save_userNewConfirm,
  delete_userNew,
} from "@/api/api.admin.js";

export default {
  props: {
    dialog: { Boolean, default: false },
    idUtente: { Number, default: 0 },
  },

  data: () => ({
    alertElaborazione: "",
    attesaVerifica: false,
    attesaConferma: false,
    tipo: "success",
    utenteValido: false,
    utenteConfermato: false,
    datiUtente: [],
    editedItem: [],
    aggiornaGriglia: false,
  }),

  methods: {
    caricaDati() {
      // Reset
      this.alertElaborazione = "";
      this.editedItem = [];
      this.datiUtente = [];
      this.utenteValido = false;
      this.utenteConfermato = false;

      get_userNew(this.idUtente)
        .then((res) => {
          this.editedItem = res.data;

          // Controllo utente confermato
          if (this.editedItem.DataConferma != null) {
            this.tipo = "info";
            this.alertElaborazione =
              "Utente confermato il " + this.editedItem.DataConferma;

            this.utenteConfermato = true;
          }
        })
        .catch((err) => {
          console.log("nuovoutente.vue " + err);
        });
    },

    elimina() {
      if (this.idUtente == 0) return;

      this.$root
        .$confirm("Elimina", "Vuoi eliminare il dato ?")
        .then((confirm) => {
          if (!confirm) return;

          delete_userNew(this.idUtente)
            .then((res) => {
              // Indica se ricaricare i dati presenti nella griglia sotto
              this.aggiornaGriglia = true;

              this.close();
            })
            .catch((err) => {
              console.log("usernew.vue " + err);
            });
        });
    },

    verifica() {
      // Pulizia
      this.attesaVerifica = true;
      this.utenteValido = false;
      this.alertElaborazione = "";
      this.datiUtente = [];

      get_userNewValidate(this.idUtente)
        .then((res) => {
          this.datiUtente = res.data;

          this.attesaVerifica = false;

          // Controllo email
          if (this.datiUtente.EMailConferma.length == 0) {
            this.tipo = "info";
            this.alertElaborazione = "Dati incompleti. EMail non valida ";

            return;
          }

          this.tipo = "success";
          this.alertElaborazione = "Utente trovato";

          this.utenteValido = true;
        })
        .catch((err) => {
          this.attesaVerifica = false;

          this.tipo = "warning";
          this.alertElaborazione = err.response.data.Message;

          console.log("usernew.vue " + err);
        });
    },

    conferma() {
      this.$root
        .$confirm("Conferma", "Vuoi confermare l'utente  ?")
        .then((confirm) => {
          if (!confirm) return;

          this.attesaConferma = true;

          save_userNewConfirm(this.datiUtente)
            .then((res) => {
              this.tipo = "success";
              this.alertElaborazione = "Utente confermato";
              this.attesaConferma = false;

              this.caricaDati();

              // Indica se ricaricare i dati presenti nella griglia sotto
              this.aggiornaGriglia = true;
            })
            .catch((err) => {
              this.attesaConferma = false;
              this.tipo = "warning";
              this.alertElaborazione = err.response.data.Message;

              console.log("usernew.vue " + err);
            });
        });
    },

    close() {
      this.$emit("close");

      // Controllo se aggiornare la griglia
      if (this.aggiornaGriglia) {
        this.aggiornaGriglia = false;
        this.$emit("caricaDatiGriglia");
      }
    },
  },

  watch: {
    dialog(val) {
      if (!val) return;

      this.caricaDati();
    },
  },
};
</script>
